import {ProfissionalOrcamentoController} from "./profissionalOrcamentoController";

declare var window: any;
import { ControllerBase } from 'controllerBase';

export const EditarIndicadorController = ControllerBase.extend({
    name: "EditarIndicadorController",

    framework: "knockout",

    ajax: function() {

        if (this.orcamento.get("Indicador")) {
            this.codigoIndicador = null;
        }

        return {
            url: "/Orcamento/_Indicador",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoIndicador: this.codigoIndicador
            }
        };

    },

    formConfig: {
        selector: "#form-indicador",
        submit: {
            selector: "#salvar-indicador",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "js"
        }
    },

    antesRenderizacaoCompleta: function() {

        this.addActionButton({
                text: "Limpar",
                'class': "icone-excluir separador",
                click: $.proxy(function() {

                        this.limpar();

                    },
                    this)
            },
            true);
        $("input").on('focus', function () { $(this).select(); });
    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },


    limpar: function() {

        var self = this;

        global.ajax({
            url: "/Orcamento/RemoverIndicador",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                self.orcamento.unset("Indicador");

                setTimeout(function () {
                    self.parent.parent.renderizarViewIndicadores();
                }, 1000);
            }
        });

    },

    salvar: function(model) {

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirIndicador",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                indicador: model
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Indicador definido com sucesso.");
                }

                self.orcamento.set("Indicador", data);

                self.model.BaseCalculoComissao(data.Indicador.BaseCalculoComissao);
                self.model.ValorComissao(data.Indicador.ValorComissao);
                self.model.EnderecoFaturamentoIndicador(data.Indicador.EnderecoFaturamentoIndicador);
                self.model.LiberarPagamentoComissaoCaixa(data.Indicador.LiberarPagamentoComissaoCaixa);


            }
        });

    }

});

(window as any).EditarIndicadorController = EditarIndicadorController
